var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"page-user-list"}},[_c('iframe',{staticStyle:{"border":"0px"},attrs:{"src":"https://gtbrdd.typeform.com/to/gNOoQ6","width":"100%","height":"700px"}})])
}]

export { render, staticRenderFns }